"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleAccount = void 0;
var json_1 = require("../../util/json");
var auth_1 = require("@terra-money/terra.proto/cosmos/auth/v1beta1/auth");
var any_1 = require("@terra-money/terra.proto/google/protobuf/any");
var BaseAccount_1 = require("./BaseAccount");
/**
 * Stores information about an account fetched from the blockchain.
 */
var ModuleAccount = /** @class */ (function (_super) {
    __extends(ModuleAccount, _super);
    /**
     * Creates a new Module accout object, holding information about a module account.
     *
     * @param name name of the module e.g 'alliance', 'bank', 'distribution'...
     * @param permissions permissions of the module to operate 'burner', 'staking'...
     * @param baseAccount basic account information of the module
     */
    function ModuleAccount(name, permissions, baseAccount) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.permissions = permissions;
        _this.baseAccount = baseAccount;
        return _this;
    }
    ModuleAccount.prototype.getAccountNumber = function () {
        var _a;
        return ((_a = this.baseAccount) === null || _a === void 0 ? void 0 : _a.account_number)
            ? this.baseAccount.account_number
            : 0;
    };
    ModuleAccount.prototype.getSequenceNumber = function () {
        var _a, _b;
        return ((_a = this.baseAccount) === null || _a === void 0 ? void 0 : _a.sequence) ? (_b = this.baseAccount) === null || _b === void 0 ? void 0 : _b.sequence : 0;
    };
    ModuleAccount.prototype.getPublicKey = function () {
        var _a, _b;
        return ((_a = this.baseAccount) === null || _a === void 0 ? void 0 : _a.public_key) ? (_b = this.baseAccount) === null || _b === void 0 ? void 0 : _b.public_key : null;
    };
    ModuleAccount.prototype.toAmino = function (_) {
        _;
        var _a = this, name = _a.name, permissions = _a.permissions, baseAccount = _a.baseAccount;
        return {
            type: 'cosmos-sdk/ModuleAccount',
            value: {
                name: name,
                permissions: permissions,
                base_account: baseAccount === null || baseAccount === void 0 ? void 0 : baseAccount.toAmino(_),
            },
        };
    };
    ModuleAccount.fromAmino = function (data, _) {
        _;
        var _a = data.value, name = _a.name, permissions = _a.permissions, base_account = _a.base_account;
        return new ModuleAccount(name, permissions, base_account ? BaseAccount_1.BaseAccount.fromAmino(base_account, _) : undefined);
    };
    ModuleAccount.fromData = function (data, _) {
        _;
        var name = data.name, permissions = data.permissions, base_account = data.base_account;
        return new ModuleAccount(name, permissions, base_account ? BaseAccount_1.BaseAccount.fromData(base_account, _) : undefined);
    };
    ModuleAccount.prototype.toData = function (_) {
        _;
        var _a = this, name = _a.name, permissions = _a.permissions, baseAccount = _a.baseAccount;
        return {
            '@type': '/cosmos.auth.v1beta1.ModuleAccount',
            name: name,
            permissions: permissions,
            base_account: baseAccount === null || baseAccount === void 0 ? void 0 : baseAccount.toData(_),
        };
    };
    ModuleAccount.prototype.toProto = function (_) {
        _;
        var _a = this, name = _a.name, permissions = _a.permissions, baseAccount = _a.baseAccount;
        return auth_1.ModuleAccount.fromPartial({
            name: name,
            permissions: permissions,
            baseAccount: baseAccount === null || baseAccount === void 0 ? void 0 : baseAccount.toProto(_),
        });
    };
    ModuleAccount.fromProto = function (moduleAccountProto, _) {
        _;
        return new ModuleAccount(moduleAccountProto.name, moduleAccountProto.permissions, moduleAccountProto.baseAccount
            ? BaseAccount_1.BaseAccount.fromProto(moduleAccountProto.baseAccount, _)
            : undefined);
    };
    ModuleAccount.prototype.packAny = function (isClassic) {
        return any_1.Any.fromPartial({
            typeUrl: '/cosmos.auth.v1beta1.ModuleAccount',
            value: auth_1.ModuleAccount.encode(this.toProto(isClassic)).finish(),
        });
    };
    ModuleAccount.unpackAny = function (pubkeyAny, _) {
        _;
        return ModuleAccount.fromProto(auth_1.ModuleAccount.decode(pubkeyAny.value), _);
    };
    return ModuleAccount;
}(json_1.JSONSerializable));
exports.ModuleAccount = ModuleAccount;
//# sourceMappingURL=ModuleAccount.js.map